import { createContext } from 'react';
import { type Nullable } from '@direct-frontend/stdlib';
import {
    type IntegrationSettingsFeature,
    type SupportedIntegrationSyncTypes,
    type SupportedIntegrationTypes,
} from '../types';

type SourceBlockContextType = Nullable<{
    syncType: SupportedIntegrationSyncTypes;
    features: IntegrationSettingsFeature[];
    modalSettingsCompareBaseProps: {
        integrationType: SupportedIntegrationTypes | undefined;
    };
    modalSettingsCompareByOn: {
        isOpen: boolean;
        open: (integrationType?: SupportedIntegrationTypes) => void;
        close: () => void;
    };
    modalSettingsCompareExtendedByOn: {
        isOpen: boolean;
        open: (integrationType?: SupportedIntegrationTypes) => void;
        close: () => void;
    };
}>;

export const SourceBlockContext = createContext<SourceBlockContextType>(null);
